export default {
    patentReview: {
        list: {
            title: '審査タスク',
            newTask: '+ 新規審査',
            empty: '審査タスクはまだありません',
            emptyHint: '特許出願原稿をアップロードして形式審査を開始',
            rules: '件のルール',
            tabTasks: 'タスク一覧',
            tabRules: 'カスタムルール管理',
        },
        status: {
            pending: '待機中',
            running: '実行中',
            completed: '完了',
            failed: '失敗',
        },
        steps: {
            '1_parsing': 'ファイル解析',
            '2_extracting': '四要素抽出',
            '3_figure_analysis': '図面分析',
            '4_formal_check': '形式審査',
            '5_substantive_check': '実質審査',
            '6_finalizing': '最終報告',
        },
        stepStatus: {
            done: '完了',
            running: '実行中',
            failed: '失敗',
            pending: '待機中',
        },
        consistencyStep: {
            title: '開示の一致性',
        },
        stabilityStep: {
            title: '安定性分析',
        },
        upload: {
            title: '新規審査タスク',
            mainFile: {
                title: '出願書類の初稿をアップロード',
                hint: 'PDF、DOCX',
            },
            figureSection: {
                addButton: '図面',
                title: '図面',
                hint: 'ドラッグ＆ドロップまたは複数選択でアップロード',
            },
            disclosureSection: {
                addButton: '技術開示書',
                title: '技術開示書',
                hint: 'ドラッグ＆ドロップまたは複数選択でアップロード',
            },
            customRulesSection: {
                addButton: 'カスタムルール',
                title: 'カスタムルール',
                dialogTitle: 'カスタムルールライブラリ',
                searchPlaceholder: 'ルールライブラリ名を検索',
                historyGroup: '過去のルールライブラリ',
                newGroup: '今回の新規アップロード',
                uploadButton: 'ルールをアップロード',
                uploadFormats: '.docx / .pdf / .pptx に対応',
                confirm: '選択を確認',
                empty: 'ルールライブラリはまだありません。「ルールをアップロード」で追加してください',
                rulesEmpty: 'このルールライブラリからルールは抽出されませんでした',
                loadFailed: 'ルールライブラリ一覧の読み込みに失敗しました。再試行してください',
                uploadFailed: 'ルールファイルのアップロードに失敗しました。再試行してください',
            },
            patentOffice: '特許庁',
            officeHint: '切り替えると対応する法条と審査基準が自動的に適用されます',
            officeComingSoon: '近日公開',
            patentType: {
                label: '特許種別',
                invention: '発明',
                utility: '実用新案',
            },
            ruleType: {
                label: 'ルールタイプ',
                official: '公式ルール',
                officialCustom: '公式ルール＋カスタムルール',
            },
            chooseFile: 'ファイルを選択',
            fileHint: '.docx / .pdf に対応、最大 {max} ファイルまで',
            confirm: '審査を開始',
            uploading: 'アップロード中…',
            cancel: 'キャンセル',
            removeFile: '削除',
        },
        detail: {
            backToList: '一覧に戻る',
            taskHeader: {
                entry: '核稿審査',
                projectPackage: '特許審査プロジェクトパッケージ',
                unnamedTask: '無題のタスク',
                progressTitle: '審査進捗',
                autoRun: '自動実行',
                exportReport: 'レポートを出力',
                exportNotReady: '審査完了後に出力できます',
                finalizingCardSubtitle: '総合結論',
                stepsExecutedCaption: '4つのプロセスが実行済み',
                parsingCaption: '解析中',
                issueCountSuffix: '{count} 件の問題',
            },
            materials: {
                mainFileTag: '特許出願書類',
                figureTag: '図面',
                disclosureTag: '開示資料',
                attachmentTag: '添付ファイル',
            },
            parsing: {
                fileName: 'ファイル名',
                fileNamePending: 'メインファイルを識別中…',
                hint: 'アップロードされたファイルを解析しています…',
            },
            extracting: {
                title: '発明の名称',
                abstract: '要約',
                claims: '特許請求の範囲',
                specification: '明細書',
                figures: '図面',
                expand: '展開',
                collapse: '折りたたむ',
                empty: '内容がありません',
            },
            check: {
                pass: '合格',
                passCollapsed: '合格（{count} 件）',
                filterAll: 'すべて',
                filterInfo: '情報',
                filterWarning: '警告',
                filterError: 'エラー',
                filterCritical: '重大',
                location: '位置',
                suggestion: '修正案',
                guidelineSource: '根拠出典',
                empty: '形式審査の問題はありません',
                summaryPattern: '位置を特定できる形式または企業規範の問題を {count} 件検出しました',
                statTitle: '形式問題を{count}件検出しました。うち公式ルール違反{officialCount}件、企業ルール違反{customCount}件。',
                statFormalIssues: '形式問題',
                statOfficialViolations: '公式ルール違反',
                statCustomViolations: '企業ルール違反',
                summaryTitle: '形式審査·まとめ',
                summaryRequireModify: '{count}件の修正が必要',
                summaryRequireConfirm: '{count}件の人工確認が必要',
                summaryStats: '全{total}個ルール·{requireModify}件·{requireConfirm}件·{pass}件合格',
                systemRules: 'システムルール',
                customRules: '企業ルール',
                legendPass: '合格',
                legendFail: '不合格',
                legendPending: '人工確認が必要',
                summaryAllPassed: 'すべて合格',
                coverageTitle: 'ルールカバレッジ',
                coverageSource: 'ルールソース',
                coverageTotal: 'ルール数',
                coverageFail: '不合格',
                coverageVerify: '要確認',
                coveragePending: '要再検証',
                coveragePassed: '合格',
            },
            table: {
                tabIssues: '問題特定表',
                tabCoverage: 'チェック網羅',
                sourceOfficial: '公式ルール',
                sourceCustom: '企業ルール',
                sourceCustomEmpty: '企業カスタムルールの一致データはまだありません',
                searchPlaceholder: '請求項、問題または法条を検索',
                columnIndex: '#',
                columnLocation: '具体的な位置',
                columnIssue: '検査結果/問題',
                columnStatute: '適用法条/ルール根拠',
                columnSuggestion: '修正案',
                columnEvidence: '根拠',
                evidenceEmpty: '—',
                statusPending: '修正が必要',
                statusApplied: '修正済み',
                statusIgnored: '無視済み',
                statusPass: '合格',
                coverageColumnType: 'ルールタイプ',
                coverageColumnRule: 'チェックルール',
                coverageColumnContent: 'ルール内容',
                coverageColumnResult: '検査結果',
                coverageResultEmpty: '—',
                coverageResultFound: '問題が見つかりました',
                ruleTypeOfficial: '公式ルール',
                ruleTypeCustom: '企業ルール',
                itemUnit: '件',
                columnPatentChapter: '特許章節',
                columnCheckRule: 'チェックルール',
                columnCheckResult: '検査結果',
                columnErrorReason: 'エラー理由',
                editButton: '編集',
                adoptButton: '修正を採用',
                locateButton: 'エラー位置の特定',
                locationModalTitle: 'エラー位置',
                locationModalContent: '位置情報：{location}',
                locationModalClose: '閉じる',
                locationModalRuleLabel: 'チェックルール',
                locationModalLocationLabel: '位置',
                locationModalSuggestionLabel: '修正内容',
                locationModalBoundaryLabel: '適用範囲',
                locationModalSourceTitle: 'ソース内容',
                locationModalPositionUnresolved: 'エラー位置を特定できません',
                statusRequireModify: '修正が必要',
                statusRequireConfirm: '人工確認が必要',
                statusPendingVerification: '要再検証',
            },
            finalizing: {
                conclusion: '総合結論',
                totalRules: 'ルール総数',
                passCount: '合格',
                warningCount: '警告',
                errorCount: 'エラー',
                criticalCount: '重大エラー',
                conclusions: {
                    formal: '形式審査の結論',
                    art26_3: '第26条第3項の結論',
                    art26_4: '第26条第4項の結論',
                },
                riskMatrix: {
                    title: '実体審査リスクレベル分布',
                    high: '高リスク',
                    medium: '中リスク',
                    low: '低リスク',
                },
                conclusionValue: {
                    compliant: '適合',
                    risky: '基本的に適合だがリスクあり',
                    non_compliant: '不適合の可能性あり',
                    insufficient: '資料不足のため判断不可',
                },
                dimensionConclusions: {
                    title: '検査項目の結論',
                    unresolved: '未判定',
                },
            },
            featureMapping: {
                figuresNone: '本願に図面は含まれていません',
                figuresFailed: '図面認識が完了しなかったため、本判断に図面内容は反映されていません',
                figureNoLabel: '図{no}',
                figureNoUnknown: '図番号が付されていません',
                figureConfidenceMedium: '図番号は推定値です',
                figureConfidenceLow: '図番号を特定できません',
                figureSignsLabel: '符号',
                figureNoSigns: '符号は確認できません',
            },
            substantive: {
                filterHigh: '高リスク',
                filterMedium: '中リスク',
                filterLow: '低リスク',
                filterAll: 'すべて',
                needsInventorConfirm: '発明者による確認が必要',
                boundaryLabel: '適用範囲',
                summaryPattern: '実体的な問題を {count} 件検出しました。各項目を確認してください',
                issuesLocations: '形式問題定位',
                title: '実質審査',
                checkResultTitle: '検査結果',
                issuesCount: '実質問題',
                highRiskCount: '高リスク問題',
            },
            supplement: {
                title: '必要な補充資料一覧',
                columns: {
                    content: '補充すべき内容',
                    reason: '理由',
                    targetStatute: '対象となる法条の問題',
                    suggestedLocation: '推奨される補充箇所',
                },
                empty: '必要な補充資料はありません',
            },
            failed: {
                retryHint: '審査タスクが失敗しました。一覧に戻って再アップロードしてください',
            },
            reportLoadFailed: {
                message: '審査レポートの読み込みに失敗しました。再試行してください',
                retry: '再読み込み',
            },
            stepRunning: 'このステップは実行中です。完了後に結果が表示されます…',
            noStepSelected: 'ステップを選択すると詳細が表示されます',
        },
        customRuleDocuments: {
            delete: '削除',
            deleteConfirm: '削除しますか？',
            confirmYes: '確認',
            confirmNo: 'キャンセル',
            empty: 'ルールドキュメントはまだありません',
            rulesEmpty: 'このドキュメントからルールは抽出されませんでした',
            rulesLoadFailed: 'ルール詳細の読み込みに失敗しました。再試行してください',
            rulesCount: '{count} 件のルール',
            status: {
                uploaded: 'アップロード済み',
                parsing: '解析中',
                parsed: '解析済み',
                parse_failed: '解析失敗',
            },
            upload: {
                title: 'ルールドキュメントをアップロード',
                addButton: 'ルールドキュメントをアップロード',
                fileTitle: 'ルールドキュメントをアップロード',
                fileHint: 'PDF、DOCX',
                chooseFile: 'ファイルを選択',
                removeFile: '削除',
                confirm: 'アップロード',
                uploading: 'アップロード中…',
            },
            loadFailed: 'ルールドキュメントの読み込みに失敗しました。再試行してください',
            uploadFailed: 'ルールドキュメントのアップロードに失敗しました。再試行してください',
            updateFailed: '更新に失敗しました。再試行してください',
            deleteSuccess: '削除に成功しました',
            deleteFailed: '削除に失敗しました。再試行してください',
        },
        errors: {
            createTaskFailed: '審査タスクの作成に失敗しました。再試行してください',
            loadTaskFailed: 'タスク状態の読み込みに失敗しました。再試行してください',
            loadReportFailed: '審査レポートの読み込みに失敗しました。再試行してください',
            loadTasksFailed: 'タスク一覧の読み込みに失敗しました。再試行してください',
            unsupportedOffice: '現在この特許庁はサポートされていません',
            exportReportFailed: '審査レポートの出力に失敗しました。再試行してください',
        },
    },
};
